import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { Vehicle } from '@commons/models/domain/Vehicle';
import { VehicleControlIndicator } from '@commons/models/domain/VehicleControlIndicator';
import { VehicleListTypeDataVisible } from '../configurator-list-vehicle/configurator-list-vehicle.component';
import { NetworkType } from '@src/app/enum/network.enum';

@Component({
  selector: 'app-list-vehicle-item',
  templateUrl: './list-vehicle-item.component.html',
  styleUrls: ['./list-vehicle-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListVehicleItemComponent implements OnInit {
  public readonly VEHICLE_LIST_TYPE_DATA = VehicleListTypeDataVisible;
  public readonly NETWORK_TYPE = NetworkType;

  @Input() isSelected?: boolean;
  @Input() listDataTypeVisible: VehicleListTypeDataVisible;
  @Input() isEtoll: boolean;
  @Input() hasBlockerReadPermissionUser: boolean;

  @Input() set vehicle(value: Vehicle) {
    this.vehicleValue = new Vehicle(value, this.translate);
    this.params = this.vehicleValue.ControlIndicators;
    this.checkBlockerStatus();

    this.updateVehicleAngle(value?.VehicleAngle || 0);
  }

  public vehicleAngle: number = 0;
  public vehicleValue: Vehicle;
  public params?: VehicleControlIndicator[] = [];
  public isBlocked?: boolean;

  constructor(
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.checkBlockerStatus();
  }

  private checkBlockerStatus(): void {
    if (this.hasBlockerReadPermissionUser && (this.vehicleValue?.blockerParametrId || this.vehicleValue?.blockerParametrIdOut2)) {
      const control = this.vehicleValue.blockerParametrId ? this.vehicleValue.ControlIndicators?.find(item => item.Id === this.vehicleValue.blockerParametrId) : null;
      const controlOut2 = this.vehicleValue.blockerParametrIdOut2 ? this.vehicleValue.ControlIndicators?.find(item => item.Id === this.vehicleValue.blockerParametrIdOut2) : null;
      this.isBlocked = control?.LV?.V || controlOut2?.LV?.V;
    }
  }

  private updateVehicleAngle(newValue: number): void {
    if(newValue !== this.vehicleAngle) {
      this.vehicleAngle = newValue;
    }
  }

}
